export default "__VITE_ASSET__DjGahmKI__"